<template>
	<div
		v-show="show"
		v-bind="$attrs"
		class="vs-component con-vs-popup ld-popup vs-popup-primary buttonClose"
	>
		<div @click="closeWithBackground" class="vs-popup--background" :class="{'background-disabled': disabledBackgoundClose}"></div>
		<div class="vs-popup" :class="{'fullscreen': fullscreen}" :style="backgroundColor ? `background: ${backgroundColor};` : 'background: rgb(255, 255, 255);'">

			<header class="vs-popup--header" v-if="title">
				<div class="vs-popup--title"><h3>{{title}}</h3></div>
				<i
					v-if="buttonCloseHidden"
					@click="show = false"
					class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
					style="background: rgb(255, 255, 255);"
					>close</i
				>
			</header>

			<div class="vs-popup--content">
				<slot name="header" />
				<slot />
				<slot name="footer" />
				<button type="button" class="btn-close" @click="show = false"></button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "LdPopup",
	inheritAttrs: true,
	props: {
		fullscreen: {
			default: false,
			required: false
		},
		backgroundColor: String,
		backgroundColorPopup: String,
		title: String,
		active: Boolean,
		buttonCloseHidden: {
			type: Boolean,
			default: false
		},
		closed: {
			type: Function,
			required: false
		},
		disabledBackgoundClose: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		show: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			}
		}
	},
	methods: {
		buttonFocus() {
			const button = this.$el.querySelector("button");

			setTimeout(() => {
				if (button) {
					button.focus();
				}
			}, 0);
		},
		closeWithBackground() {
			if (!this.disabledBackgoundClose) {
				this.show = false;
			}
		},
		hiddenMainScroll() {
			const $main = document.querySelector("body");

			if ($main) {
				$main.style.overflowY = "hidden";
			}
		},
		showMainScroll() {
			const $main = document.querySelector("body");

			if ($main) {
				$main.style.overflowY = "auto";
			}
		},
		setScrollTop() {
			const $content = this.$el.querySelector(".vs-popup--content");

			if ($content) {
				setTimeout(() => {
					$content.scrollTop = 0;
				}, 100);
			}
		}
	},
	watch: {
		active() {
			if (!this.active && !!this.closed) {
				this.closed();
			}

			if (this.active) {
				// this.buttonFocus();
				// this.hiddenMainScroll();
				this.setScrollTop();
			} else {
				// this.showMainScroll();
			}
		},
	},
	errorCaptured() {
		return false;
	},
};
</script>

<style lang="scss" scoped>
	.ld-popup {

		.vs-popup {
			width: auto;
			min-width: 350px;
			height: auto;

			&.fullscreen {
				width: 100%;
				height: 100%;
			}
		}

		.background-disabled {
			pointer-events: none !important;
		}
	}
</style>
